import { SupplementaryEquipment } from './supplementary-equipment';
import { RoutingPosition } from './routing-position';
import { Transport } from "../../../common/model/transport.model";
import { TransportOptionSelection } from '../../transport-options-panel/transport-options-panel.model';

export enum TransportManagementLevel {
  LIFECYCLE = 'LIFECYCLE', LOCATION = 'LOCATION'
}

export class TransportRegistration {

  vehicleId: number;
  registerNow: boolean;
  changeRouteManually: boolean;
  useAsShuttle: boolean;
  noSupplementaryEquipmentHandout: boolean;

  transport: Transport;

  selectedOptions = new Array<TransportOptionSelection>();
  supplementaryEquipments: SupplementaryEquipment[] = [];
  routingPositions: RoutingPosition[] = [];

  constructor(registration?: TransportRegistration) {
    if (registration != null) {
      this.vehicleId = registration.vehicleId;
      this.registerNow = registration.registerNow;
      this.changeRouteManually = registration.changeRouteManually;
      this.useAsShuttle = registration.useAsShuttle;
      this.noSupplementaryEquipmentHandout = registration.noSupplementaryEquipmentHandout;

      if (registration.transport != null) {
        this.transport = new Transport(registration.transport);
      }
      if (registration.selectedOptions != null) {
        for (const o of registration.selectedOptions) {
          this.selectedOptions.push(new TransportOptionSelection(o));
        }
      }
      if (registration.supplementaryEquipments != null) {
        for (const se of registration.supplementaryEquipments) {
          this.supplementaryEquipments.push(new SupplementaryEquipment(se));
        }
      }
      if (registration.routingPositions != null) {
        for (const rp of registration.routingPositions) {
          this.routingPositions.push(new RoutingPosition(rp));
        }
      }
    }
  }
}
